(() => {
  const init = (root) => {
    if (root.dataset.dividerReady) return;
    root.dataset.dividerReady = 'true';
    const group = root.querySelector('.edrc__rhythm-options');
    const drawing = root.querySelector('[data-rhythm-drawing]');
    const title = root.querySelector('[data-rhythm-title]');
    const copy = root.querySelector('[data-rhythm-copy]');
    if (!group || !drawing || !title || !copy) return;
    const states = {
      open: {title: 'A lighter connection.', copy: 'Wider gaps leave a more open view between adjoining spaces.', label: 'Illustration of evenly spaced wood slats with wider gaps'},
      screened: {title: 'A more sheltered corner.', copy: 'A greater proportion of wood filters more of the view. The final effect also depends on profile depth and viewing angle.', label: 'Illustration of broader wood slats with narrower gaps for more screening'}
    };
    group.hidden = false;
    group.addEventListener('click', (event) => {
      const button = event.target.closest('button[data-rhythm]');
      if (!button || !group.contains(button)) return;
      const state = states[button.dataset.rhythm];
      if (!state) return;
      group.querySelectorAll('button').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      drawing.dataset.rhythmDrawing = button.dataset.rhythm;
      drawing.setAttribute('aria-label', state.label);
      title.textContent = state.title;
      copy.textContent = state.copy;
    });
  };
  const scan = () => document.querySelectorAll('[data-divider-collection]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, {once: true});
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();
